import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { IconButton, TooltipHost } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpIcon } from './help-icon';

const getStyles = () => ({
  button: {
    height: '48px',
    width: '48px',
    maxWidth: '48px',
    '&:hover': {
      '& .HelpTopic >path': {
        fill: '#0f6cbd',
      },
    },
  },
});

export const HelpButton = () => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);

  return (
    <TooltipHost content={i18n.getString(_TL_('Help'))} calloutProps={{ doNotLayer: true }}>
      <IconButton
        className={classNames(classes.button, 'help-button', 'HelpTopic')}
        aria-label={i18n.getString(_TL_('Help'))}
        id="help-button"
      >
        <HelpIcon className="HelpTopic" />
      </IconButton>
    </TooltipHost>
  );
};
